import { render, staticRenderFns } from "./RegistrationStatus.vue?vue&type=template&id=399c0270&scoped=true"
import script from "./RegistrationStatus.vue?vue&type=script&lang=js"
export * from "./RegistrationStatus.vue?vue&type=script&lang=js"
import style0 from "./RegistrationStatus.vue?vue&type=style&index=0&id=399c0270&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399c0270",
  null
  
)

export default component.exports